import axios from 'axios';

export default axios.create({
  // baseURL:"https://localhost:7253/api",
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});
